import { URL_STATUSES } from '../../constants';

export const SOCIAL_MEDIA_TYPE = {
  YOUTUBE: 'YOUTUBE',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
  TIKTOK: 'TIKTOK',
  LINKEDIN: 'LINKEDIN',
  TRUSTPILOT: 'TRUSTPILOT',
};

const getDropdownValues = (options) => {
  return options.map((op) => op.value);
};

const getSocialUrls = (urls, crawledUrls, socialType) => {
  const crawledUrl = crawledUrls[socialType];

  const splittedUrls = urls.split(',').map((url) => url.trim());

  return splittedUrls.map((url) => ({ url, status: url === crawledUrl ? URL_STATUSES.SUCCESS : URL_STATUSES.ERROR }));
};

const mapDatasetToDto = (id, formValues, crawledUrls) => {
  return {
    projectId: id,
    country: formValues.country,
    brandCompany: formValues.brandCompany,
    domain: formValues.domain,
    competitorType: formValues.competitorType,
    inEcosystem: formValues.inEcosystem,
    inFocus: formValues.inFocus,
    myCompany: Boolean(formValues.myCompany),

    categories: getDropdownValues(formValues.categories),
    groups: getDropdownValues(formValues.groups),
    products: getDropdownValues(formValues.products),
    services: getDropdownValues(formValues.services),

    socials: Object.values(SOCIAL_MEDIA_TYPE).reduce((acc, curr) => {
      if (formValues[curr]) {
        acc[curr] = getSocialUrls(formValues[curr], crawledUrls, curr);
      }

      return acc;
    }, {}),
  };
};

export default mapDatasetToDto;
